import { common } from '@ocean/ui'
import { layouts } from '@ocean/ui'
import { LayoutProps, DetailsHeaderLayoutSegmentProps } from 'layouts/types'
import withLayout from 'layouts/withLayout'
import {
  Root,
  BackgroundContainer,
  Wrapper,
  Content,
  HeaderWrapper,
  ContentWrapper,
  ContentInfo,
  Title,
  SubTitle,
  Sidebar,
} from './DetailsHeaderLayout.styled'

const { SectionLayout } = layouts

const { Decorator, DecoratorVariant } = common

export type DetailsHeaderLayoutSegments = 'sidebar' | 'header' | 'title' | 'subtitle' | 'background'
type InternalLayoutProps = LayoutProps<DetailsHeaderLayoutSegments>

export const DetailsHeaderSegment: React.FC<DetailsHeaderLayoutSegmentProps> = ({ children }) => (
  <>{children}</>
)

const DetailsHeaderLayout = ({ segments }: InternalLayoutProps) => (
  <Root>
    <Decorator wrapper variant={DecoratorVariant.Pattern} backgroundColor='oceanDark'>
      {segments?.background && <BackgroundContainer>{segments.background}</BackgroundContainer>}
      <SectionLayout>
        <Wrapper>
          <Content>
            {segments?.header && <HeaderWrapper>{segments.header}</HeaderWrapper>}
            <ContentWrapper>
              <ContentInfo>
                {segments?.title && <Title>{segments.title}</Title>}
                {segments?.subtitle && <SubTitle>{segments.subtitle}</SubTitle>}
              </ContentInfo>
            </ContentWrapper>
          </Content>
          {segments?.sidebar && <Sidebar>{segments.sidebar}</Sidebar>}
        </Wrapper>
      </SectionLayout>
    </Decorator>
  </Root>
)

export default withLayout(DetailsHeaderLayout)
